import React, { useState, useEffect, useRef } from "react"
import Airtable from "airtable"
import "../styles/App.scss"
//Components
import HomeHeader from "../components/HomeHeader.jsx"
import Search from "../components/Search.jsx"
import Card from "../components/Card.jsx"
import Footer from "../components/Footer.jsx"
// Utils
import { IntersectionObserver } from "../utils/IntersectionObserver"
import Spinner from "../utils/Spinner"

const provider = ""

const Home = () => {
  // Estado que almacena el valor del input en <Search />
  const [input, setInput] = useState({ inputValue: "" })
  /* Este estado almacena la información contenida en
  las tarjetas de cada obra */
  const [store, setStore] = useState([])
  const containerRef = useRef(null)
  const [isVisible, setIsVisible] = useState(false)

  const callbackFunction = entries => {
    const [entry] = entries
    setIsVisible(entry.isIntersecting)
    console.log("In viewport")
  }

  const options = {
    root: null,
    rootMargin: "0px",
    thresold: 1.0,
  }

  // Airtable API
  const retrieveTable = () => {
    let base = new Airtable({ apiKey: "keyRICOfYlRaLgFzw" }).base(
      "appLpc9Ewre2aXiiz"
    )

    base("Obras General")
      .select({
        fields: ["No.", "OBRA", "CONTRATISTA", "PORTADA"],
        view: "Grid view",
      })
      .eachPage(
        function page(records, fetchNextPage) {
          // This function (`page`) will get called for each page of records.

          records.forEach(function (record) {
            setStore(elem => [
              ...elem,
              {
                desc: record.get("OBRA").toUpperCase(),
                id: record.get("No."),
                image: record.get("PORTADA"),
              },
            ])
          })
          fetchNextPage()
        },
        function done(err) {
          if (err) {
            console.error(err)
            return
          }
        }
      )
  }

  // Se realiza el API request principal
  useEffect(() => {
    retrieveTable()
  }, [])

  // Cambia el valor de nuestra entrada en el buscador usando onChange()
  function cardFilter(event) {
    setInput(elements => ({
      ...elements,
      inputValue: event.target.value,
    }))
    event.persist()
  }

  // Filtro de aquellos items que coinciden con el input del buscador
  const filteredItems = store.filter(elem => {
    return elem.desc.toLowerCase().includes(input.inputValue.toLowerCase())
  })

  return (
    <>
      <HomeHeader />
      <Search cardFilter={cardFilter} inputValue={input.inputValue} />
      <div className="items-container">
        <div className="card-container">
          {filteredItems.length > 0 ? (
            // Para cada elemento en el filtro de búsqueda:
            filteredItems.map((value, id) => (
              <IntersectionObserver key={id}>
                <Card
                  key={id}
                  item={value.item}
                  image={value.image}
                  id={value.id}
                  description={value.desc}
                />
              </IntersectionObserver>
            ))
          ) : // Sí aún no hay elementos en el arreglo, muestra el loader:
          store.length === 0 ? (
            <Spinner />
          ) : (
            //Sí hay elementos y ninguno hace match en la búsqueda:
            <h1 className="notfound">No hemos encontrado ese resultado :(</h1>
          )}
        </div>
      </div>
      <Footer />
    </>
  )
}

export default Home
